import { FC } from 'react';
import { LogoProps } from './Logo.types';
import { LogoIcon } from './Logo.styles';
import logo from '../../assets/moa-white-logo.svg';

const Logo: FC<LogoProps> = () => <LogoIcon src={logo} alt='logo' />;

export default Logo;
